"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteCommentApi = exports.QuoteCommentApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * QuoteCommentApi - axios parameter creator
 * @export
 */
const QuoteCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} quoteId
         * @param {ICommentEntity} iCommentEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuoteComment: async (quoteId, iCommentEntity, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('addQuoteComment', 'quoteId', quoteId);
            // verify required parameter 'iCommentEntity' is not null or undefined
            (0, common_1.assertParamExists)('addQuoteComment', 'iCommentEntity', iCommentEntity);
            const localVarPath = `/api/quote/comment/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (quoteId !== undefined) {
                localVarQueryParameter['quote_id'] = quoteId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCommentEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} quoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuoteComments: async (quoteId, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('listQuoteComments', 'quoteId', quoteId);
            const localVarPath = `/api/quote/comment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (quoteId !== undefined) {
                localVarQueryParameter['quote_id'] = quoteId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.QuoteCommentApiAxiosParamCreator = QuoteCommentApiAxiosParamCreator;
/**
 * QuoteCommentApi -
 */
var QuoteCommentApi;
(function (QuoteCommentApi) {
    /**
     *
     * @param {number} quoteId
     * @param {ICommentEntity} iCommentEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteCommentApi
     * url /api/quote/comment/add
     */
    async function addQuoteComment(quoteId, iCommentEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addQuoteComment(quoteId, iCommentEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseICommentEntity)(res.data);
            return res;
        });
    }
    QuoteCommentApi.addQuoteComment = addQuoteComment;
    /**
     *
     * @param {number} quoteId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteCommentApi
     * url /api/quote/comment/list
     */
    async function listQuoteComments(quoteId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listQuoteComments(quoteId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseICommentEntity)(x));
            return res;
        });
    }
    QuoteCommentApi.listQuoteComments = listQuoteComments;
})(QuoteCommentApi || (exports.QuoteCommentApi = QuoteCommentApi = {}));
